<template>
  <div class="card p-3 shadow">
    <div v-if="!showForm" class="pt-2 mb-3">
      <button class="btn btn-primary" @click="showForm = true">
        Добавить заметку
      </button>
    </div>

    <Form
        v-if="showForm"
        :note="note"
        v-on:cancel="closeForm"
        v-on:submit="submitForm" />

    <List
        v-else
        :notes="notes"
        v-on:select="selectNote"/>
  </div>
</template>

<script>
import Form from './note/Form';
import List from './note/List';

export default {
  name: 'ClientNote',

  components: {List, Form},

  props: ['client'],

  data() {
    return {
      loading: true,
      showForm: false,
      noteId: null,
    };
  },

  created() {
    this.loadUserData();
  },

  computed: {
    notes() {
      return this.$store.getters.clientNotes(this.client.id);
    },

    note() {
      return this.notes.find(note => note.id === this.noteId);
    },
  },

  methods: {
    async loadUserData() {
      try {
        this.loading = true;

        await this.$store.dispatch('NOTES_LOAD_ITEMS', this.client.id);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },

    selectNote(id) {
      this.noteId = id;
      this.showForm = true;
    },

    closeForm(id) {
      this.noteId = null;
      this.showForm = false;
    },

    async submitForm(text) {
      if (this.loading) {
        return false;
      }

      this.loading = true;

      try {
        let method = 'NOTES_ADD_ITEM';
        const data = { client: this.client.id, text };

        if (typeof this.note !== 'undefined') {
          method = 'NOTES_UPDATE_ITEM';
          Object.assign(data, { id: this.note.id });
        }

        await this.$store.dispatch(method, data);

        this.showForm = false;
      } catch (e) {
        this.$store.dispatch('ERROR', e);
      }

      this.loading = false;
    },
  },
};
</script>
